import React, { useEffect, useState } from 'react';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function StickyWidget() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isScrolled || answeredCount === 0) return null;
  const title = answeredCount >= 4 ? "You're halfway there" : 'Score started';
  const handleFinishClick = () => {
    openDiagnostic();
  };
  const dots = Array.from({
    length: 8
  });
  return <>
      {/* Desktop card — lower right, paper surface, calm progress cue */}
      <div className="animate-in fade-in slide-in-from-bottom-4 fixed bottom-8 right-8 z-50 hidden w-[19rem] flex-col gap-3.5 rounded-2xl border border-gray-200/70 bg-paper p-5 text-navy shadow-[0_24px_48px_-18px_rgba(26,40,56,0.28)] duration-500 md:flex" data-id="element-567" data-mp="1rmlbhbvxdcbg">
        <div className="flex items-center justify-between gap-4" data-id="element-568" data-mp="36fpw91ve4hzh">
          <div data-id="element-569" data-mp="36f6a18ypj7fn">
            <div className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-seaglass" data-id="element-570" data-mp="36hshl8lllmxv">
              {title}
            </div>
            <div className="text-sm font-medium text-text-muted" data-id="element-571" data-mp="3ffusqgz1pvyv">
              {answeredCount} of 8 answered
            </div>
          </div>
          <Cta variant="primary" size="sm" showArrow onClick={handleFinishClick} className="flex-shrink-0 shadow-none hover:shadow-none hover:translate-y-0" data-id="element-572" data-mp="2rogz87p5rucb">
            Finish
          </Cta>
        </div>
        {/* Segmented sea-glass progress cue — no ring, no meter */}
        <div className="flex items-center gap-1.5" data-id="element-573" data-mp="2wouz32glvxz9">
          {dots.map((_, i) => <div key={i} className={`h-1.5 flex-1 rounded-full ${i < answeredCount ? 'bg-seaglass' : 'bg-gray-200'}`} data-id="element-574" data-mp="28zacm9l8uil8" data-mpi={i} />)}
        </div>
      </div>

      {/* Mobile bottom bar */}
      <div className="animate-in slide-in-from-bottom-full fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between border-t border-gray-200/70 bg-paper px-4 py-3 text-navy shadow-[0_-10px_30px_rgba(26,40,56,0.12)] duration-300 md:hidden" data-id="element-575" data-mp="7xufmvevgdys">
        <div className="flex items-center gap-2 text-sm" data-id="element-576" data-mp="ho5tpas9s3je">
          <span className="font-semibold" data-id="element-577" data-mp="lpr1wituztn9">Score</span>
          <span className="text-gray-300" data-id="element-578" data-mp="lofvsccxy9sz">&middot;</span>
          <span className="font-semibold text-seaglass" data-id="element-579" data-mp="3l54i1x2que3o">{answeredCount}/8</span>
        </div>
        <Cta variant="primary" size="sm" showArrow onClick={handleFinishClick} className="min-h-[44px] shadow-none hover:shadow-none hover:translate-y-0" data-id="element-580" data-mp="3q2xo8q41r83y">
          Finish
        </Cta>
      </div>
    </>;
}